/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Secondary_Opacity_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Secondary Opacity" |
*
* @param {Styles_Secondary_Opacity_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_secondary_opacity_aria_label = /** @type {((inputs?: Styles_Secondary_Opacity_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Secondary_Opacity_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opacite secondaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekundäre Opazität")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opacità secondaria")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вторичная непрозрачность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opacidad secundaria")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继发性不透明度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("二次不透明度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("द्वितीयक अपारदर्शिता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opacidade secundária")
	return /** @type {LocalizedString} */ ("Secondary Opacity")
});